import React, { useMemo } from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import { useAuth } from 'context/Auth';
import { useCurrentInstaller } from 'hooks/UseCurrentInstaller';
import { useMyTasks } from 'hooks/UseMyTasks';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import {
  enrichFachinteressentCardsWithAemIcons,
  getFachinteressentMyDataCards,
} from 'components/CardCollectionMyData/FachinteressentMyDataCards';
import { CardComponent } from 'components/CardComponent';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';
import { SubTitle } from 'components/SubTitle/SubTitle';

import { MEINE_AUFGABEN_CARD_ID, PFLEGENDE_BU_ID_TO_NAME } from 'global/constants';

import { parseCardsMyData } from 'utils/CardDataUtils';
import { isFachinteressent, shouldShowMyDataCard } from 'utils/InstallerUtils';
import { isBUofCurrentTenant } from 'utils/tenantUtil';

import './CardCollectionMyData.sass';

const CardCollectionMyData = (props) => {
  const { links } = props;
  const isEditor = Utils.isInEditor();

  const { isCIAM } = useAuth();
  const parsedCards = useMemo(() => parseCardsMyData(links), [links]);
  const { installer, isLoading } = useCurrentInstaller();
  const { openTaskCount } = useMyTasks({ skip: isEditor });
  const cardsToRender = useMemo(() => {
    if (!installer || !isFachinteressent(installer)) {
      return parsedCards;
    }

    return enrichFachinteressentCardsWithAemIcons(getFachinteressentMyDataCards(), parsedCards);
  }, [installer, parsedCards]);

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="CardCollectionMyData" />;
  }
  if (isLoading || !installer) {
    return (
      <SubTitle
        className="card-collection-my-data__sub-title-wrapper"
        text={
          isCIAM === false
            ? 'Nutzen Sie das Installateurs-Login um Ihre Daten zu verwalten'
            : 'Lädt...'
        }
      />
    );
  }
  return (
    <div className="card-collection-my-data">
      <div className="mdl-grid card-collection-my-data__card-grid">
        {isBUofCurrentTenant(installer.pflegendeBu) ? (
          cardsToRender.map((card) => {
            if (!isFachinteressent(installer) && !shouldShowMyDataCard(card.id, installer)) {
              return null;
            }

            let renderedCard = card;
            const isMeineAufgabenCard =
              card.id === MEINE_AUFGABEN_CARD_ID || card.title === 'Meine Aufgaben';
            if (isMeineAufgabenCard) {
              renderedCard = {
                ...card,
                teaser: {
                  elementsList: [{ name: 'Offene Aufgaben', number: openTaskCount }],
                },
              };
            }
            return (
              <Link key={card.id} to={card.linkedPage}>
                <CardComponent
                  cardClass={`search-pre-selection-card mdl-cell mdl-cell--4-col${
                    isMeineAufgabenCard ? ' search-pre-selection-card--task' : ''
                  }`}
                  card={renderedCard}
                />
              </Link>
            );
          })
        ) : (
          <SubTitle
            className="card-collection-my-data__sub-title-wrapper"
            text={`Nutzen Sie das Portal Ihres pflegenden Netzbetreibers ${
              PFLEGENDE_BU_ID_TO_NAME[installer.pflegendeBu]
            }. Wählen Sie diesen über Portalwechsel aus.`}
          />
        )}
      </div>
    </div>
  );
};
CardCollectionMyData.propTypes = {
  links: PropTypes.array.isRequired,
};
MapTo('e-fix/components/content/cardcollectionMyData')(CardCollectionMyData);
